import RecoverPassword from './RecoverPassword';

export default RecoverPassword;
